import { Directive } from '@angular/core';
import { TravelMetadata } from 'src/app/_types/lead.types';

import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class TravelMetadataComponentAbstract extends BaseMetadataComponent<TravelMetadata> {}
